module.exports = __webpack_public_path__ + "img/email.90481358.png";